// send-to-lister task L2: a session opened by Buy / Trade shows where it came from, right
// below the title row — the same conditional-render position VerdictBanner uses.
//
// grader/grade/cert (review I2(b)) are Buy / Trade's own entered values for a card or slab —
// null for sealed/lot/other and for a raw card Buy / Trade never graded. `mismatch` is the
// plain-language warning (built by `buyTradeCertMismatch`, ui/src/lib/lister-state.ts) for when
// they differ from what the session's own photographs and cert lookup settled on; null means
// nothing to flag, and nothing renders.
//
// `condition` (X1, send-to-lister cross-app review) is Buy / Trade's own raw condition label —
// shown here so a sealed box's real condition is never only an internal fact the Map pass was
// told and the operator never saw. `conditionFlag` (built by `buyTradeConditionFlag`) is the
// same null-means-nothing-to-flag shape as `mismatch`, for when it isn't "Factory sealed".
export default function BuyTradeBadge({ dealNumber, sku, grader, grade, cert, condition, mismatch, conditionFlag }: {
  dealNumber: string; sku: string;
  grader: string | null; grade: string | null; cert: string | null;
  condition: string | null;
  mismatch: string | null;
  conditionFlag: string | null;
}) {
  const gradeLine = [grader, grade].filter(Boolean).join(" ");
  return (
    <div className="space-y-1">
      <div className="border border-zinc-800 bg-zinc-900 rounded-md px-3 py-2 font-mono text-sm text-zinc-300" role="status">
        From Buy / Trade · {dealNumber} · {sku}
        {(gradeLine || cert) && <> · {[gradeLine || null, cert ? `cert ${cert}` : null].filter(Boolean).join(" · ")}</>}
        {condition && <> · {condition}</>}
      </div>
      {mismatch && <p className="text-amber-300 text-xs" role="alert">{mismatch}</p>}
      {conditionFlag && <p className="text-amber-300 text-xs" role="alert">{conditionFlag}</p>}
    </div>
  );
}
